import { useEffect } from 'react';
import isEmpty from 'lodash/isEmpty';

const useFetchStyliticsData = ({
  error,
  count,
  tagValue,
  uniqueKey,
  isRedirectToPDP,
  shopByLookStyliticsData,
  fetchShopByLookStyliticsData,
}) => {
  const dataList = shopByLookStyliticsData?.[uniqueKey] || [];
  useEffect(() => {
    if (dataList?.length === 0) {
      fetchShopByLookStyliticsData(tagValue, count, uniqueKey, isRedirectToPDP);
    }
  }, [uniqueKey, dataList?.length]);

  const isDataUnavailable = dataList.length === 0 && isEmpty(error);

  return { dataList, isDataUnavailable };
};

export default useFetchStyliticsData;
